import axios from 'axios';
import { createSignedGetRequest } from 'utils/createSignedRequestsHelpers';

export const getUserProjectPreferences = async ({
  activeEmployerInfo = {},
  isLocalApiRequest = false,
} = {}) => {
  const apiPath = 'user/projects/preferences';

  const signedRequest = await createSignedGetRequest({
    apiPath,
    activeEmployerInfo,
    isLocalApiRequest,
  });

  const response = await axios(signedRequest);

  return response.data;
};
